/// <reference types="@angular/localize" />

// import { init, BrowserTracing } from "@sentry/angular-ivy";
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { init, BrowserTracing } from "@sentry/angular-ivy";
// import { inject } from '@vercel/analytics';

// import { AppModule } from './app/app.module';
// import { provideAnimations } from '@angular/platform-browser/animations';

import './zone-flags';
import { environment } from '@environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// add vercel analytics tag
if (environment.production) {
  // // vercel analytics
  // inject();
  // if (environment.sentryDsn) {
  //   // sentry
  //   init({
  //     dsn: environment.sentryDsn,
  //     integrations: [
  //       new BrowserTracing({
  //         tracePropagationTargets: ["localhost", environment.apiUrl],
  //       }),
  //     ],
  //     // Performance Monitoring
  //     tracesSampleRate: 0.1,
  //   });
  // }
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
